import NotificationTranslationsRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/NotificationService/NotificationTranslationsRequest";


export default class EmailPushTranslateViewModel {
    langCode?: string = '';
	title?: string = '';
	text?: string = '';
    constructor(obj?: Partial<EmailPushTranslateViewModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toServerModel(): NotificationTranslationsRequest {
        const res = new NotificationTranslationsRequest({            
            LangCode: this.langCode,
            Title: this.title,
            Text: this.text
        });
        return res;
    }
}
